import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree} from '@angular/router';
import {LoanApplicationService} from '../service/loan-application.service';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {Injectable} from '@angular/core';

@Injectable()
export class OnlyBorrowerApplicantsGuard implements CanActivate {
    constructor(private loanApplicationService: LoanApplicationService,
                private loanApplicationInteractor: LoanApplicationInteractor) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const loanApplication = await this.loanApplicationInteractor.get();
        try {
            return !!await this.loanApplicationService.getLatestTransition(loanApplication.id);
        } catch (error) {
            return error.status === 404;
        }
    }
}
